const reCAPTCHAkey = {
  devSitekey: process.env.REACT_APP_RECAPTCHAKEY_DEV, ///Dev site key
  UATSitekey: process.env.REACT_APP_RECAPTCHAKEY_UAT, ///UAT site key
  localhostSitekey: process.env.REACT_APP_RECAPTCHAKEY_LOCALSITEKEY ///Localhost site key
};

export default reCAPTCHAkey;
